import { render } from "./leaves-employee.vue?vue&type=template&id=49bc4f9e&scoped=true"
import script from "./leaves-employee.vue?vue&type=script&lang=js"
export * from "./leaves-employee.vue?vue&type=script&lang=js"

import "./leaves-employee.vue?vue&type=style&index=0&id=49bc4f9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bc4f9e"]])

export default __exports__